import type { ConfigType } from '@plone/registry';
import { applyStyleWrapperToBlock } from '@eeacms/volto-block-style';
import installSettings from './config/settings';
import installBlocks from './config/blocks';
import MarkersWidget from './components/Blocks/Location/MarkersWidget';
import './theme/main.scss';
import './components/AIImageTool/ai-image-tool.scss';

function applyConfig(config: ConfigType) {
  (config as any).widgets.widget.markers_map = MarkersWidget;

  installSettings(config);
  installBlocks(config);

  config.views.contentTypesViews.Menu = config.views.layoutViews.document_view;

  Object.keys(config.blocks.blocksConfig).forEach((id) => {
    const blockConfig = config.blocks.blocksConfig[id];
    if (blockConfig.edit && !(blockConfig.edit as any)._styleWrapped) {
      config.blocks.blocksConfig[id] = applyStyleWrapperToBlock(blockConfig);
    }
  });

  return config;
}

export default applyConfig;
